import { useCallback, useEffect, useState } from "react";

import { dismissUntil, isDismissed } from "../utils/dismissalStore";
import { useAuth } from "../providers/AuthProvider";

type UseDismissableNoticeOptions = {
  id?: string | null;
  durationSeconds?: number;
  onDismiss?: () => void;
  userId?: string | null;
};

const DEFAULT_DURATION_SECONDS = 7 * 24 * 60 * 60;

export function useDismissableNotice({
  id,
  durationSeconds = DEFAULT_DURATION_SECONDS,
  onDismiss,
  userId,
}: UseDismissableNoticeOptions = {}) {
  const { user } = useAuth();
  const scopedUserId = userId ?? user?.id ?? null;

  const [hidden, setHidden] = useState(() => {
    return id ? isDismissed(id, scopedUserId) : false;
  });

  useEffect(() => {
    if (id) {
      setHidden(isDismissed(id, scopedUserId));
    }
  }, [id, scopedUserId]);

  const dismiss = useCallback(() => {
    if (id) {
      dismissUntil(id, Date.now() + durationSeconds * 1000, scopedUserId);
    }
    setHidden(true);
    onDismiss?.();
  }, [durationSeconds, id, onDismiss, scopedUserId]);

  return { hidden, dismiss };
}
